import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideTranslateService } from '@ngx-translate/core';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { tokenRefreshInterceptor } from '@interceptors/token-refresh.interceptor';
import { dataSourceInterceptor } from '@interceptors/data-source.interceptor';
import { caseNormalizationInterceptor } from '@interceptors/case-normalization.interceptor';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideToastr } from 'ngx-toastr';
import { SentryConfig } from '../modules/sentry.module';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withXhr(),
      withInterceptors([
        caseNormalizationInterceptor,
        tokenRefreshInterceptor,
        dataSourceInterceptor,
      ]),
    ),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json',
      }),
    }),
    provideToastr({
      preventDuplicates: true,
    }),
    ...SentryConfig,
  ],
};
